<div *ngIf="(uiState$ | async) as ui">
  <div *ngIf="ui.users.length > 0">
    <div *ngFor="let user of ui.users" class="mb-4">
      <div class="font-bold mb-2 flex align-items-center">
        <span>{{ user.name }}</span>
        <span class="text-sm text-gray-500 ml-2">({{ user.email }})</span>

        <button *ngIf="mode === 'update'" pButton type="button" icon="pi pi-trash" 
                class="p-button-rounded p-button-text p-button-warning ml-2"
                (click)="onDeleteUser(user.userId, user.name)"></button>
      </div>
      <form [formGroup]="user.form" (ngSubmit)="onSave(user.userId, user.form)">
        <p-multiSelect
          formControlName="permissions"
          [options]="ui.orgLevelPermissions"
          optionLabel="displayName"
          optionValue="id"
          display="chip"
          class="w-full mb-2 mr-2"
          styleClass="long-chips-multiselect"
          [filter]="false"
          [showToggleAll]="true"
          [placeholder]="'SELECT_PERMISSIONS' | translate"
        ></p-multiSelect>
        <button *ngIf="mode === 'update'" pButton type="submit" [label]="'SAVE' | translate" class="p-button-sm"></button>
      </form>
    </div>
  </div>
  <div *ngIf="ui.users.length === 0" class="text-gray-500">
    {{ 'NO_USERS_FOUND' | translate }}
  </div>
  <div *ngIf="ui.error" class="text-red-500 mt-2">{{ ui.error }}</div>
</div>

<!-- Dialog for confirming removal of all permissions -->
<p-dialog
  [header]="'WARNING' | translate"
  [(visible)]="showConfirmDialog"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="true"
  styleClass="w-[30rem]"
>
  <div class="mb-4">
    {{ 'REMOVE_ALL_PERMISSIONS_MSG' | translate }}<br>
    {{ 'REMOVE_ALL_PERMISSIONS_DETAIL' | translate }}
  </div>
  <div class="flex justify-end gap-2">
    <button pButton type="button" [label]="'REMOVE_ALL_PERMISSIONS' | translate" class="p-button-danger mr-4" (click)="onConfirmRemoveAll()"></button>
    <button pButton type="button" [label]="'CANCEL' | translate" class="p-button-text" (click)="onCancelRemoveAll()"></button>
  </div>
</p-dialog>

<!-- Dialog for confirming user deletion -->
<p-dialog
  [header]="'CONFIRM_DELETION' | translate"
  [(visible)]="showDeleteConfirmDialog"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="true"
  styleClass="w-[30rem]"
>
  <div class="mb-4">
    <p>{{ 'CONFIRM_DELETE_USER_MSG' | translate }} <b>{{ pendingDeleteUserName }}</b>?</p>
    <p class="mt-2 text-orange-500">{{ 'DELETE_USER_DETAIL' | translate }}</p>
    <p class="mt-2">{{ 'REMOVE_USER_INSTEAD' | translate }}</p>
  </div>
  <div class="flex justify-end gap-2">
    <button pButton type="button" [label]="'DELETE_USER' | translate" class="p-button-danger mr-4" (click)="onConfirmDelete()"></button>
    <button pButton type="button" [label]="'CANCEL' | translate" class="p-button-text" (click)="onCancelDelete()"></button>
  </div>
</p-dialog>
